import React from 'react';
import Fuse from 'fuse.js';
import { IVenue } from 'btdt-types';

interface IProps {
  name: string;
  venues: IVenue[];
  onSuggestEdit(venue: IVenue): void;
  onDismiss(): void;
}

function DuplicateVenueWarning({ name, venues, onSuggestEdit, onDismiss }: IProps): React.ReactElement | null {
  const [dismissed, setDismissed] = React.useState(false);

  const matches = React.useMemo(() => {
    if (!name || name.length < 2) return [];
    const fuse = new Fuse(venues, {
      keys: ['name', 'nameEn'],
      threshold: 0.4,
    });
    return fuse.search(name).slice(0, 5).map((r) => r.item);
  }, [name, venues]);

  React.useEffect(() => {
    setDismissed(false);
  }, [name]);

  if (!matches.length || dismissed) return null;

  return (
    <div style={{ background: '#4a3a1a', border: '1px solid #aa8833', borderRadius: 8, padding: 12, margin: '8px 0' }}>
      <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>נראה שכבר יש מקום דומה במפה:</p>
      {matches.map((venue) => (
        <div key={venue.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0' }}>
          <span>{venue.name} — {venue.address}</span>
          <button
            type="button"
            onClick={() => onSuggestEdit(venue)}
            style={{ background: 'none', border: 'none', color: '#aaccff', cursor: 'pointer', fontSize: 13, textDecoration: 'underline', whiteSpace: 'nowrap', marginRight: 8 }}
          >
            להציע תיקון למקום הזה?
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={() => { setDismissed(true); onDismiss(); }}
        style={{ background: 'none', border: '1px solid #888', borderRadius: 4, color: '#ddd', cursor: 'pointer', padding: '4px 12px', marginTop: 8, fontSize: 13 }}
      >
        זה מקום אחר, להמשיך
      </button>
    </div>
  );
}

export default DuplicateVenueWarning;
